/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/

import { Box } from '@mui/material';
import React from 'react'
import  Account  from '../../../components/Views/user/account/Account'; 

const AccountPage = () => {
    return (
        <Box m={6}>
            <Account />
        </Box>
    )
}

export default AccountPage;